<template>
  <v-dialog :value="value" max-width="500" scrollable @input="$emit('input', $event)">
    <v-card v-if="aulaSelecionada" style="max-height: 60vh">
      <v-card-title>
        Detalhes da Aula
        <v-spacer></v-spacer>
        <v-btn icon @click="$emit('input', false)">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="">
        <v-card outlined class="mb-6">
          <v-card-title class="subtitle-1 font-weight-bold primary--text">
            Experiências
          </v-card-title>
          <v-divider />
          <v-card-text class="content-box">
            <ul>
              <li v-for="rotina in aulaSelecionada.rotinas" :key="rotina.id">
                <strong>{{ rotina.descricao }}</strong>
                <div>
                  {{ rotina.experiencias.join(", ") || "- - -" }}
                </div>
              </li>
            </ul>
          </v-card-text>
        </v-card>

        <v-card outlined class="mb-6">
          <v-card-title class="subtitle-1 font-weight-bold primary--text">
            Direitos de Aprendizagem
          </v-card-title>
          <v-divider />
          <v-card-text class="content-box">
            <ul>
              <li v-for="rotina in aulaSelecionada.rotinas" :key="rotina.id">
                <strong>{{ rotina.descricao }}</strong>
                <ul>
                  <li v-for="(direito, i) in rotina.direitos_aprendizagem" :key="i">
                    {{ direito || "- - -" }}
                  </li>
                </ul>
              </li>
            </ul>
          </v-card-text>
        </v-card>

        <v-card outlined class="mb-6">
          <v-card-title class="subtitle-1 font-weight-bold primary--text">
            Campos de experiências
          </v-card-title>
          <v-divider />
          <v-card-text class="content-box">
            <ul>
              <li v-for="rotina in aulaSelecionada.rotinas" :key="rotina.id">
                <strong>{{ rotina.descricao }}</strong>
                <ul>
                  <li v-for="(campo, i) in rotina.campos_experiencia_aula" :key="i">
                    {{ campo || "- - -" }}
                  </li>
                </ul>
              </li>
            </ul>
          </v-card-text>
        </v-card>

        <v-card outlined class="mb-6">
          <v-card-title class="subtitle-1 font-weight-bold primary--text">
            Objetivos de Aprendizagem e Desenvolvimento
          </v-card-title>
          <v-divider />
          <v-card-text class="content-box">
            <ul>
              <li v-for="rotina in aulaSelecionada.rotinas" :key="rotina.id">
                <strong>{{ rotina.descricao }}</strong>
                <p>{{ rotina.objetivos_aprendizagem || "- - -" }}</p>
              </li>
            </ul>
          </v-card-text>
        </v-card>

        <v-card outlined class="mb-6">
          <v-card-title class="subtitle-1 font-weight-bold primary--text">
            Orientações Metodológicas
          </v-card-title>
          <v-divider />
          <v-card-text class="content-box">
            <ul>
              <li v-for="rotina in aulaSelecionada.rotinas" :key="rotina.id">
                <strong>{{ rotina.descricao }}</strong>
                <p>{{ rotina.orientacoes_metodologicas || "- - -" }}</p>
              </li>
            </ul>
          </v-card-text>
        </v-card>

        <v-card outlined class="mb-6">
          <v-card-title class="subtitle-1 font-weight-bold primary--text"> Recursos </v-card-title>
          <v-divider />
          <v-card-text class="content-box">
            <ul>
              <li v-for="rotina in aulaSelecionada.rotinas" :key="rotina.id">
                <strong>{{ rotina.descricao }}</strong>
                <p>{{ rotina.recursos || "- - -" }}</p>
              </li>
            </ul>
          </v-card-text>
        </v-card>

        <v-card outlined class="mb-6">
          <v-card-title class="subtitle-1 font-weight-bold primary--text"> Avaliação </v-card-title>
          <v-divider />
          <v-card-text class="content-box">
            <div>{{ aulaSelecionada.avaliacao || "- - -" }}</div>
          </v-card-text>
        </v-card>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    aulaSelecionada: {
      type: Object,
      default: null,
    },
  },
};
</script>
